//TODO: Refactor 
import {
  DiscordIcon,
  TwoDElementsIcon,
  TwoDElementsIconOutlined,
  TwoDElementsIconOutlinedLarge,
  TwoDElementsMobileIcon,
  TwoDElementsIconFilledLarge,
  ThreeDElementsIcon,
  ThreeDElementsMobileIcon,
  ThreeDElementsIconOutlined,
  ThreeDElementsIconOutlinedLarge,
  ThreeDElementsIconFilledLarge,
  VideoIconOutlined,
  VideoIconFilledLarge,
  ReportBugIcon,
  LightbulbIconOutline,
  AVFXContributor,
  AcademyIcon,
  VideoIconOutlinedLarge
} from '../modules/Icons';
import New from '../pages/users/reset/new';

export const AccountNavigation = [
  {
    text: 'My Wishlists',
    href: '/accounts/wishlists',
    icon: null
  },
  {
    text: 'My Downloads',
    href: '/accounts/downloads',
    icon: null
  },
  {
    text: 'Account Settings',
    href: '/accounts/profile',
    icon: null
  },
  {
    text: 'Manage Subscription',
    href: '/accounts/subscriptions',
    icon: null
  },
  {
    text: 'Order History',
    href: '/accounts/orders',
    icon: null
  },
  {
    text: 'Manage Team',
    href: '/accounts/team',
    icon: null
  }
];

export const AccountSupportNavigation = [
  {
    text: 'Suggest a Product',
    href: 'https://actionvfx.featurebase.app/?b=65bfb4720ed972a2431dad35',
    icon: <LightbulbIconOutline className={`inline-block stroke-inherit fill-none`} />
  },
  {
    text: 'Sell on ActionVFX',
    href: 'https://sell.actionvfx.com/',
    icon: <AVFXContributor className={`inline-block stroke-inherit fill-none`} />
  },
  {
    text: 'Report a Bug',
    href: 'https://actionvfx.featurebase.app/?b=65bfdd430ed972a24368d358',
    icon: <ReportBugIcon className={`inline-block stroke-inherit`} />
  }
];

export const TopNavigationAssets = [
  {
    text: '2D Elements',
    description: 'Stock Footage and textures for VFX',
    href: '/products',
    api: '/collections?library_id=1&',
    icon: <TwoDElementsIcon className={`inline-block fill-inherit`} />,
    iconOutlined: <TwoDElementsIconOutlined className={`inline-block fill-inherit`} />,
    iconOutlinedLarge: <TwoDElementsIconOutlinedLarge className={`inline-block`} />,
    iconFilled: <TwoDElementsMobileIcon className={`inline-block w-[30px] h-[30px]`} />,
    iconFilledLarge: <TwoDElementsIconFilledLarge className={`inline-block fill-inherit`} />,
    library: 'library2d',
    libraryId: 1,
    children: []
  },
  {
    text: '3D Assets',
    description: '3D Models, VDBs, and more assets',
    href: '/3d',
    api: '/collections?library_id=2&',
    icon: <ThreeDElementsIcon className={`inline-block fill-inherit`} />,
    iconOutlined: <ThreeDElementsIconOutlined className={`inline-block fill-inherit`} />,
    iconOutlinedLarge: <ThreeDElementsIconOutlinedLarge className={`inline-block`} />,
    iconFilled: <ThreeDElementsMobileIcon className={`inline-block w-[30px] h-[30px] !stroke-a-blue`} />,
    iconFilledLarge: <ThreeDElementsIconFilledLarge className={`inline-block fill-inherit`} />,
    library: 'library3d',
    libraryId: 3,

    children: []
  },
  {
    text: 'Academy',
    description: 'Learn VFX',
    href: '/academy',
    api: '/edu_assets&',
    icon: <AcademyIcon className={`inline-block`} />,
    iconOutlined: <VideoIconOutlined className={`inline-block fill-inherit`} />,
    iconOutlinedLarge: <VideoIconOutlinedLarge className={`inline-block`} />,
    iconFilled: <AcademyIcon className={`inline-block w-[30px] h-[30px]`} />,
    iconFilledLarge: <VideoIconFilledLarge className={`inline-block fill-inherit`} />,
    library: '',
    libraryId: null,
    children: [
      {
        text: 'Tutorials',
        href: '/academy/tutorials',
        icon: null
      },
      {
        text: 'Courses',
        href: '/academy/courses',
        icon: null
      },
      {
        text: 'Practice Footage',
        href: '/academy/free-resources',
        icon: null
      }
    ]
  }
];

export const TopNavigationLearn = [
  {
    text: 'Learn',
    href: null,
    icon: null,
    children: [
      {
        text: 'Practice Footage',
        href: '/practice-footage',
        icon: null
      },
      {
        text: 'Tutorials',
        href: '/blog?category=tutorials',
        icon: null
      },
      {
        text: 'Blog',
        href: '/blog',
        icon: null
      }
    ]
  },
  {
    text: 'Community',
    href: null,
    icon: null,
    children: [
      {
        text: 'Join our Discord',
        href: 'https://discord.gg/SEeuP5Mtku',
        icon: <DiscordIcon className={`inline-block fill-inherit`} />
      },
      {
        text: 'Request a Product',
        href: 'https://actionvfx.featurebase.app/?b=65bfb4720ed972a2431dad35',
        icon: null
      },
      {
        text: 'Testimonials',
        href: '/testimonials',
        icon: null
      }
    ]
  }
];
